import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import InfoBar from "@/components/InfoBar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <InfoBar />
      <Header />
      <main className="flex-1 stb-section">
        <div className="stb-container">{children}</div>
      </main>
      <Footer />
    </div>
  );
}
